import Swiper from 'swiper'
import {Navigation} from "swiper/modules";

export default function () {
    document.addEventListener('DOMContentLoaded', () => {

        function init(element: HTMLElement) {
            const sliderEl = element
            const parent = sliderEl?.parentElement

            const prevEl = parent?.querySelector('.slider-control-left') as HTMLElement
            const nextEl = parent?.querySelector('.slider-control-right') as HTMLElement
            if (!sliderEl) return
            new Swiper(sliderEl, {
                spaceBetween: '16px',
                slidesPerView: 1,
                speed: 500,
                loop: true,
                modules: [Navigation],
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },
                breakpoints: {
                    440: {
                        slidesPerView: 1
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: '24px',
                    },
                },
            })
        }


        const sliderElements = document.querySelectorAll<HTMLElement>('[data-info-boxes-slider]')

        if (sliderElements.length > 0) {
            sliderElements.forEach((element) => {
                if (element instanceof HTMLElement) {
                    init(element)
                }
            })
        }
    })
}
